<template>
  <div class="calendar-month-days--wrapper">
    <div
      class="calendar-month-days--days"
      :class="markWeeks ? 'mark-weeks' : ''"
    >
      <div
        v-for="day in days"
        :key="day.id"
        class="calendar-month-days--day"
        :class="{
          today: day.today,
          sunday: day.sunday,
          saturday: day.saturday,
          selected: day.selected,
          selectedWeek: day.selectedWeek,
          filled: day.filled,
        }"
        @click="selectDay(day.date.year, day.date.month, day.date.day)"
      >
        <span class="name">{{ day.name }}</span>
        <span class="id">{{ day.id }}</span>
        <span class="mark-week"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CalendarMonthDays',
  props: {
    selectedDate: {
      type: Object,
      default: () => ({
        year: 0,
        month: 0,
        day: 0,
      }),
    },
    dotMarkedDates: {
      type: Array,
      default: function() {
        return []
      },
    },
    viewedMonth: {
      type: Number,
      default: 0,
    },
    viewedYear: {
      type: Number,
      default: 0,
    },
    markWeeks: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dayNames: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
      today: new Date(),
    }
  },
  created() {},
  computed: {
    selectedDateAsDate() {
      const date = new Date()
      date.setFullYear(
        this.selectedDate.year,
        this.selectedDate.month - 1,
        this.selectedDate.day,
      )
      return this.$moment(date)
    },
    daysInMonthArray() {
      const date = new Date()
      date.setFullYear(this.viewedYear, this.viewedMonth - 1)

      return Array.from(
        {
          length: this.$moment(date).daysInMonth(),
        },
        (v, k) => k + 1,
      )
    },
    days() {
      let daysInMonthFullList = []
      let startWeek = this.$moment(this.selectedDateAsDate).startOf('week')
      let endWeek = this.$moment(this.selectedDateAsDate).endOf('week')
      this.daysInMonthArray.forEach((index, value) => {
        let tmpDay = {}
        let dayDate = new Date()
        dayDate.setFullYear(this.viewedYear, this.viewedMonth - 1, index)
        let date = this.$moment(dayDate)
        tmpDay.id = index
        tmpDay.date = {
          day: index,
          month: this.viewedMonth,
          year: this.viewedYear,
        }
        tmpDay.simpleDate = date.format('YYYY-MM-DD')
        tmpDay.name = this.dayNames[date.day()]
        if (date.day() == 0) tmpDay.sunday = true
        if (date.day() == 6) tmpDay.saturday = true
        if (date.isSame(this.today, 'day')) tmpDay.today = true
        if (this.markWeeks) {
          if (date.isSameOrBefore(endWeek) && date.isSameOrAfter(startWeek))
            tmpDay.selectedWeek = true
        } else if (date.isSame(this.selectedDateAsDate, 'day'))
          tmpDay.selected = true
        if (this.dotMarkedDates.includes(tmpDay.simpleDate))
          tmpDay.filled = true
        daysInMonthFullList.push(tmpDay)
      })
      return daysInMonthFullList
    },
    dotMarkedDatesComputed() {
      let arr = []
      this.dotMarkedDates.forEach(o => {
        let date = this.$moment(o)
        arr.push(date)
      })
      return arr
    },
  },
  methods: {
    selectDay(year, month, day) {
      this.$emit('selectDate', { year, month, day })
    },
  },
}
</script>
<style lang="scss" scoped>
.calendar-month-days {
  &--days {
    display: flex;
    justify-content: space-between;
  }
  &--day {
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    cursor: pointer;
    z-index: 1;
    flex-grow: 1;
    background: transparent;
    -webkit-transition-duration: 100ms;
    -moz-transition-duration: 100ms;
    -ms-transition-duration: 100ms;
    -o-transition-duration: 100ms;
    transition-duration: 100ms;
    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: $bh-blue--2;
      left: 50%;
      opacity: 0;
      transform: translate3d(-50%, 0, 0);
      -webkit-transition-duration: 100ms;
      -moz-transition-duration: 100ms;
      -ms-transition-duration: 100ms;
      -o-transition-duration: 100ms;
      transition-duration: 100ms;
    }
    &::before {
      content: '';
      width: 30px;
      left: 50%;
      transform: translate3d(-50%, 0%, 0);
      top: -12px;
      height: 56px;
      border-radius: 22px;
      border: 2px solid $bh-blue--4;
      background: $bh-blue--4;
      position: absolute;
      display: block;
      z-index: -1;
      opacity: 0;
      -webkit-transition-duration: 100ms;
      -moz-transition-duration: 100ms;
      -ms-transition-duration: 100ms;
      -o-transition-duration: 100ms;
      transition-duration: 100ms;
    }
    .name {
      text-transform: uppercase;
      font-size: 0.642857rem;
    }
    .id {
      font-weight: bold;
    }
    .mark-week {
      background: $bh-blue--4;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: -2;
      display: block;
    }
    &.today {
      color: $bh-blue--2 !important;
      &:hover {
        color: $bh-blue--2;
      }
      &::before {
        opacity: 1;
        border-color: $bh-blue--2;
        background: $bh-white;
      }
    }
    &.selectedWeek {
      color: $bh-white;
      .mark-week {
        background: $bh-blue--2;
      }
    }
    &.selected {
      color: $bh-white !important;
      &::before {
        opacity: 1;
        background: $bh-blue--2;
        border-color: $bh-blue--2;
      }
      &::after {
        background: $bh-white;
      }
    }
    &.filled {
      &::after {
        opacity: 1;
      }
    }
    &:hover {
      color: $bh-white !important;
      &::before {
        opacity: 1;
        background: $bh-blue--2;
        border-color: $bh-blue--2;
      }
      &::after {
        background: $bh-white;
      }
    }
    &.sunday {
      margin-left: 10px;
      .mark-week {
        border-radius: 5px 0 0 5px;
      }
    }
    &.saturday {
      .mark-week {
        border-radius: 0 5px 5px 0;
      }
    }
  }
}
</style>
